module.exports = __webpack_public_path__ + "img/other.356d2299.svg";